var startOfDay=require('../start_of_day/index.js');/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */function isToday(dirtyDate){return startOfDay(dirtyDate).getTime()===startOfDay(new Date()).getTime();}module.exports=isToday;